import React, { useContext, useEffect, useState, useRef } from "react";
import PageName from "../Utils/PageName";
import { Link } from "react-router-dom";
import { environmentVariables } from "../../config/env.config";
import axios from "axios";
import { userContext } from "../../context/userContext";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "./OrderNowUpdatedStyle.css";
import styled from "styled-components";
import "react-tabs/style/react-tabs.css";
import { currencyContext } from "../../context/currencyContext.js";
import { useNavigate } from "react-router";
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import PlansAllocate from "./PlansAllocate.js";
import {useTranslation} from "react-i18next";
import { getUserPermission } from "../../utils/utility";
import { useFormik } from "formik";
import * as yup from "yup";
import CircularLoader from "../Components/CircularLoader/CircularLoader.js";

function CustomerPayinout() {
  const { t } = useTranslation();
  const baseUrl = environmentVariables?.apiUrl;
  const { userData, setUserData } = useContext(userContext);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [isAgentFound, setIsAgentFound] = useState(true);
  const [agentErrorMessage, setAgentErrorMessage] = useState('');
  const [agentsucessMessage, setAgentsucessMessage] = useState('');
  const [formName, setFormName] = useState('');
  const [submitBtn, setSubmitBtn] = useState('');
  const [data, setData] = useState([]);
  const [expiryDays, setExpiryDays] = useState();
  const [userEmail, setUserEmail] = useState("");
  const [agentCode, setAgentCode] = useState("");
  const [editedData, setEditedData] = useState({});
  const [planId, setPlanId] = useState("");
  const [handleName, setHandleName] = useState("");
  const tableExtensions = { export: false, print: false };
  const [isEditMode, setIsEditMode] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const storedUserData = localStorage.getItem("user");
  const userDataObject = JSON.parse(storedUserData);

  const [formData, setFormData] = useState({
    editPlanName : '',
    editPayin: '',
    editPayout: '',
    settlement_time: '',
    country: '',
  });

  const initialValues = {
    payin: "",
    payout: "",
    settlement_time: "",
    country: "",
  };

  let formik = useFormik({
    initialValues: initialValues,
    validationSchema: yup.object({
      plan_name: yup
        .string()
        .min(2)
        .max(50)
        .required("Plan name is required"),
    //   payin: yup
    //   .string()
    //   .required("Payin is required")
    //   .matches(/^\d+$/, "Payin must be a number")
    //   .test("is-valid-payin", "Payin must be between 0 and 90", (val) => {
    //     const num = parseInt(val, 10);
    //     return !isNaN(num) && num >= 0 && num <= 90;
    //   }),
  
    // payout: yup
    //   .string()
    //   .required("Payout is required")
    //   .matches(/^\d+$/, "Payout must be a number")
    //   .test("is-valid-payout", "Payout must be between 0 and 90", (val) => {
    //     const num = parseInt(val, 10);
    //     return !isNaN(num) && num >= 0 && num <= 90;
    //   }),
  
    // settlement_time: yup
    //   .string()
    //   .required("Settlement time is required")
    //   .matches(/^\d+$/, "Settlement time must be a number")
    //   .test("is-valid-settlement", "Settlement time must be less than or equal to 240 hours", (val) => {
    //     const num = parseInt(val, 10);
    //     return !isNaN(num) && num >= 0 && num <= 240;
    //   }),
    payin: yup
    .number()
    .typeError("Payin must be a number")
    .required("Payin is required")
    .min(0, "Payin must be at least 0")
    .max(90, "Payin must be less than or equal to 90"),

  payout: yup
    .number()
    .typeError("Payout must be a number")
    .required("Payout is required")
    .min(0, "Payout must be at least 0")
    .max(90, "Payout must be less than or equal to 90"),

  settlement_time: yup
    .number()
    .typeError("Settlement time must be a number")
    .required("Settlement time is required")
    .min(0, "Settlement time must be at least 0")
    .max(240, "Settlement time must be less than or equal to 240"),

  country: yup
        .string()
        .required("Country is required"),

    }),
    onSubmit: async (values) => {
      setIsSubmit(true);
      const payload = {
        payin: formik?.values?.payin,
        payout:formik?.values?.payout,
        settlement_time:formik?.values?.settlement_time,
        // email: formik?.values?.email,
        plan_name: formik?.values?.plan_name,
        country: formik?.values?.country,
      };

  
      try {
        const response = await axios.post(`${baseUrl}api/v1/custompayment/create_payin_payout`, payload, {
          headers: {
            'Content-Type': 'application/json',
            _token: userData?.token,
          },
        });
        toast.success(response?.data?.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        // setUserEmail('')
        // setAgentCode('')
        // // setSelectedCountry('')
        formik.resetForm();
        setIsSubmit(false);
        fetchPayinPayoutData()
        const closeModalElement = document.querySelector('#closeModal');
        if (closeModalElement) {
          closeModalElement.click();
        }
      } catch (error) {
        console.error('Error ', error);
        toast.error(error?.response?.data?.message || error?.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        setIsSubmit(false);
      }
    },
  });

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   const numericValue = value.replace(/[^0-9]/g, "");
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: numericValue,
  //   }));
  // };

  const handleChange = (e) => {
    // const { name, value } = e.target;
    // const numericValue = value.replace(/[^0-9]/g, "");
    // let validValue = numericValue;
  
    // if (name === "editPayin" || name === "editPayout") {
    //   const num = parseInt(numericValue, 10);
    //   if (!isNaN(num) && num <= 90) {
    //     validValue = numericValue;
    //   } else {
    //     validValue = ""; // clear if out of range
    //   }
    // }
  
    // if (name === "settlement_time") {
    //   const num = parseInt(numericValue, 10);
    //   if (!isNaN(num) && num <= 240) {
    //     validValue = numericValue;
    //   } else {
    //     validValue = ""; // clear if out of range
    //   }
    // }
  
    // setFormData((prevData) => ({
    //   ...prevData,
    //   [name]: validValue,
    // }));
    const { name, value } = e.target;

    if (name === "editPlanName") {
      const validValue = value.replace(/[^a-zA-Z\s]/g, ""); // Allows letters and spaces only
      setFormData((prevData) => ({
        ...prevData,
        [name]: validValue,
      }));
      return;
    }


   const decimalValue = value.replace(/[^0-9.]/g, "");

  // Prevent multiple decimal points
  const parts = decimalValue.split(".");
  let validValue = parts.length > 2
    ? parts[0] + "." + parts[1] // keep only one decimal
    : decimalValue;

  if (validValue.length > 4) {
    validValue = validValue.slice(0, 4);
  }

  const num = parseFloat(validValue);

  if (name === "editPayin" || name === "editPayout") {
    if (!isNaN(num) && num <= 90) {
      validValue = validValue;
    } else {
      validValue = ""; // Clear if invalid
    }
  }

  if (name === "settlement_time") {
    if (!isNaN(num) && num <= 240) {
      validValue = validValue;
    } else {
      validValue = ""; // Clear if invalid
    }
  }

  setFormData((prevData) => ({
    ...prevData,
    [name]: validValue,
  }));
  };
  const handlePlanClick = async () => {
    //  setEditedData({
    //   ...editedData,
    //   description: ""
    // });
    formik.resetForm();
    setEditedData({});
    setUserEmail("");
    // await setData({});
    setFormName("Create Wallet Package")
    setSubmitBtn("Save Changes")
    setHandleName("handleSubmit")

    const myClickModelElement = document.querySelector('.MyClickModel');
    if (myClickModelElement) {
      const formElement = document.getElementById('bplanForm');
      formElement.reset();
      myClickModelElement.click();
    }
  }

  const customStyles = {
    dataTableExtensions: {
      backgroundColor: "lightgray",
      padding: "10px",
    },
    headRow: {
      style: {
        backgroundColor: "#e9e9e9",
        borderRadius: "2px 2px 0 0",
        paddingLeft: "25px",
        border: "none",
        textTransform: "capitalize",
        position: "sticky",
        left: 0,
        top: 0,
        zIndex: 1,
        boxShadow: "0 2px 2px -1px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
        whiteSpace: "nowrap",
      },
    },
    headCells: {
      style: {
        color: "#525252",
        fontSize: "16px",
        minHeight: "52px",
        //   width: "135px", // Adjust the width as needed
        // overflow: "visible", 
      },
    },
    rows: {
      style: {
        padding: "6px 0px 6px 25px",
        fontSize: "14px",
        textTransform: "capitalize",
        minHeight: "48px !important",
      },
    },
    BusinessColumn: {
      position: "sticky",
      left: "0",
      zIndex: "1",
      backgroundColor: "#fff",
      overflow: "hidden",
      whiteSpace: "nowrap",
    }
  };

  const fetchPayinPayoutData = () => {
    try {
      axios
        .get(`${baseUrl}api/v1/custompayment/get_allpayinpayout?type=get`, {
          headers: {
            _token: userData?.token,
          },
        })
        .then((response) => {          
          setData(response?.data?.data)
        })
        .catch((error) => {
          setData([])
          console.error("Error:", error?.response?.data?.message);
        });
    } catch (error) {
      setData([])
      console.error("API Error:", error?.response?.data?.message);
    }
  };
  useEffect(() => {
    fetchPayinPayoutData();
  }, []);

  
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `You won't be able to revert this!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });
    if (result?.isConfirmed) {
      try {
        const response = await axios.delete(
          `${baseUrl}api/v1/custompayment/delete_payin_payout?id=${id}`,
          {
            headers: {
              _token: userData?.token,
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data.success) {
          toast.success(response?.data?.message, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          });
          
          fetchPayinPayoutData()

        } else {
          toast.warning(response?.data?.message, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          });
        }
      } catch (error) {
        const errorMsg =
                error.response?.data?.message || "Something went wrong!";
              toast.error(errorMsg, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1000,
              });
        console.error("Error deleting the plan:", error.message);
      }
    }
  };
  const handleEditOpen = async (d) => {
    setFormData({
      ...formData,
      editPlanName: d?.plan_name,
      editPayin:d?.payin,
      editPayout:d?.payout,
      settlement_time:d?.settlement_time,
      country:d?.country,
      editRecord: d, 
    })

    const myClickModelElement = document.querySelector('.EditClickModel');
    if (myClickModelElement) {
      const formElement = document.getElementById('editForm');
      formElement.reset();
      myClickModelElement.click();
    }

  }
 
  const isSuperAdmin = userDataObject?.user_type === "super_admin";
  const hasPermission = getUserPermission(userDataObject, 108);

  function useWindowWidth() {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return width;
  }




const windowWidth = useWindowWidth();

  
  const columns = [
    {
      name: t("Plan_Name"),
      selector: (row) => row?.plan_name || "--",
      cell: (row) => (
        <div className="custom-cell" data-column-name="Plan_Name">
          {row?.plan_name || "--"}
        </div>
      ),
      sortable: true,
      minWidth: windowWidth > 768 ? "200px" : "100%",
    },
    {
      name: t("Country"),
      selector: (row) => row?.countryData?.name || "--",
      cell: (row) => (
        <div className="custom-cell" data-column-name="Plan_Name">
          {row?.countryData?.name || "--"}
        </div>
      ),
      sortable: true,
      minWidth: windowWidth > 768 ? "200px" : "100%",
    },
    {
      name: t("Payin_(%)"),
      selector: (row) => row?.payin || "--",
      cell: (row) => (
        <div className="custom-cell" data-column-name="Payin_(%)">
          {row?.payin || "--"}
        </div>
      ),
      sortable: true,
      minWidth: windowWidth > 768 ? "180px" : "100%",
    },
    {
      name: t("Payout_(%)"),
      selector: (row) => row?.payout || "--",
      cell: (row) => (
        <div className="custom-cell" data-column-name="Payout_(%)">
          {row?.payout || "--"}
        </div>
      ),
      sortable: true,
      minWidth: windowWidth > 768 ? "180px" : "100%",
    },
    {
      name: t("Settlement_Time_(Hours)"),
      selector: (row) => row?.settlement_time || "--",
      cell: (row) => (
        <div className="custom-cell" data-column-name="Settlement_Time_(Hours)">
          {row?.settlement_time || "--"}
        </div>
      ),
      sortable: true,
      minWidth: windowWidth > 768 ? "180px" : "100%",
    },
    {
      name: t("Action"),
      sortable: false,
      cell: (row) => (
        <div className="custom-cell" data-column-name="Action">
          <i
            className="fas fa-trash-alt"
            style={{ padding: "0 7px", cursor: "pointer" }}
            onClick={() => handleDelete(row?.id)}
          ></i>
          &nbsp;&nbsp;&nbsp;
          <i
            className="first fas fa-pen"
            onClick={() => handleEditOpen(row)}
            data-bs-toggle="modal"
            data-bs-target="#planselect"
            style={{ cursor: "pointer" }}
          ></i>
        </div>
      ),
      minWidth: windowWidth > 768 ? "180px" : "100%",
    },
  ];
  

  const tableData = {
    columns,
    data,
  };

 const paginationOptions = {
    rowsPerPageText: t("Rows_per_page"),
    rangeSeparatorText: t("Of"),
    selectAllRowsItem: true,
    selectAllRowsItemText: t("All"),
  };

  const handleEdit = async () => {
    setIsSubmit(true);
    try {
      const payload = JSON.stringify({
        payin: formData.editPayin,
        payout: formData.editPayout,
        settlement_time: formData.settlement_time?.toString(),
        id: formData?.editRecord?.id,
        plan_name: formData?.editPlanName,
        country: formData?.country,
      });
      const response = await axios.post(`${baseUrl}api/v1/custompayment/create_payin_payout`, payload, {
        headers: {
          'Content-Type': 'application/json',
          _token: userData?.token,
        },
      });

   
      setIsSubmit(false);
      setFormData({
        editPayin: '',
        editPayout: '',
        settlement_time: '',
        id: '',
        editRecord:'',
        country:'',
      });
      fetchPayinPayoutData()
      const closeModalElement = document.querySelector('#closeModalEdit');
      if (closeModalElement) {
        closeModalElement.click();
      }
      toast.success(response?.data?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    } catch (error) {
      console.error('Request failed:', error);
      toast.error(error?.response?.data?.message || error?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
      setIsSubmit(false);
    }

  }
  const handleChangeData = (event , key) => {
    // const { value } = event.target;
    // const numericValue = value.replace(/[^0-9]/g, "");
    // formik.setFieldValue(key, numericValue);
    let { value } = event.target;
    // Allow only digits and one dot
    if (key === "plan_name") {
      value = value.replace(/[^a-zA-Z\s]/g, ''); // Allow only letters and spaces
    } else {
      // For other fields, allow only digits and one dot
      // value = value.replace(/[^0-9.]/g, '');

      // // Only allow one dot
      // const parts = value.split('.');
      // if (parts.length > 2) {
      //   value = parts[0] + '.' + parts[1];
      // }
       value = value.replace(/[^0-9.]/g, '');

      // Only allow one dot
      const parts = value.split('.');
      if (parts.length > 2) {
        value = parts[0] + '.' + parts[1];
      }

      // Limit to 4 characters total
      if (value.length > 4) {
        value = value.slice(0, 4);
      }
    }

    formik.setFieldValue(key, value);
  };

    
  
  
  
  return (
    <div id="custom_table">
      <PageName PageName="Package" />
      {(isSuperAdmin || hasPermission) && (
      <div style={{"display": "flex","justify-content": "end","gap": "20px"}}>
      <p className="addrolep">
        <span className="icon-btn addrolemain_role" onClick={handlePlanClick}>
        Create Package <span className="addrole_role">+</span>
        </span>
        <a className="MyClickModel" data-bs-toggle="modal" data-bs-target="#planselectedit"></a>
      </p>
      </div>
      )}
      <div className="scrollable-columns">
        <div className="sticky-header-container">
          <DataTableExtensions
            {...tableData}
            {...tableExtensions}
            customStyles={customStyles}
            filterPlaceholder="Search CustomizedPlans"
          >
            <DataTable
              columns={columns}
              data={data}
              noHeader
              defaultSortField="id"
              sortIcon={<SortIcon />}
              defaultSortAsc={true}
              pagination
              highlightOnHover
              dense
               paginationComponentOptions={{
                        ...paginationOptions,
                      }}
              customStyles={customStyles}
              noDataComponent={<div style={{padding:"24px"}}>{t("No_records_found")}</div>}
            />
          </DataTableExtensions>
        </div>
      </div>
      <>
        <div
          className="modal fade"
          id="planselectedit"
          backdrop="static"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg dialog_wrapper_plan_superadmin">
            <div className="modal-content ">
              <div className="modal-header" style={{display:"flex", flexDirection:"column"}}>
                <h5 className="modal-title L508" id="exampleModalLabel">
                  {formName}
                </h5>
                {/* <h5 className="lable-custompayment-form-para">( Add Payin/Payout Percentage and Settlement Time )</h5> */}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="closeModal"
                ></button>
              </div>
              <div className="modal-body ddd">
                <form id="bplanForm">

                   <div className="row g-3  mb-3">
                    <div className="col">
                      <h5 className="lable-custompayment-form">Select Country*</h5>
                      {/* Discount Type */}
                      <select
                        className="form-control"
                        name="country"
                        value={formik?.values?.country}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        <option value="" disabled> Select Country </option>
                        <option value="IN">India</option>
                        <option value="AE">United Arab Emirates</option>
                      </select>
                      {formik.touched.country && formik.errors.country ? (
                        <div style={{ color: "red" }}>
                          {formik.errors.country}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>

                  <div className="row g-3 mb-3">
                    <div className="col" style={{position:"relative"}}>
                    <h5 className="lable-custompayment-form">Enter Plan Name*</h5>
                      <input
                        type="text"
                        className="form-control"
                        style={{fontSize:"16px", padding:"12px 25px", border:"1px solid #e5e5e5", background:"#f5f5f5"}}
                        placeholder="Please Enter plan name"
                        aria-label="plan_name"
                        name="plan_name"
                        value={formik?.values?.plan_name}
                        onChange={(e)=>handleChangeData(e, "plan_name")}
                        onBlur={formik.handleBlur}
                        disabled={isEditMode}
                        />
                       
                        {formik.touched.plan_name && formik.errors.plan_name ? (
                        <div style={{ color: "red" }}>
                          {formik.errors.plan_name}
                        </div>
                        ) : (
                          <></>
                        )}
                    </div>
                  </div>

                  <div className="row g-3 mb-3">
                    <div className="col">
                    <h5 className="lable-custompayment-form">Enter Payin (In Percentage)*</h5>
                      <input
                        type="text"
                        className="form-control"
                        style={{fontSize:"16px", padding:"12px 25px", border:"1px solid #e5e5e5", background:"#f5f5f5"}}
                        placeholder="Enter Payin Percentage*"
                        name="payin"
                        value={formik?.values?.payin}
                        onChange={(e)=>handleChangeData(e, "payin")}
                        onBlur={formik.handleBlur}
                        // maxLength={2}
                      />
                       {formik.touched.payin && formik.errors.payin ? (
                        <div style={{ color: "red" }}>
                          {formik.errors.payin}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  
                  </div>
                  <div className="row g-3  mb-3">
                    <div className="col">
                    <h5 className="lable-custompayment-form">Enter Payout (In Percentage)*</h5>
                    <input
                        type="text"
                        className="form-control"
                        style={{fontSize:"16px", padding:"12px 25px", border:"1px solid #e5e5e5", background:"#f5f5f5"}}
                        placeholder="Enter Payout Percentage*"
                        name="payout"
                        value={formik?.values?.payout}
                        onChange={(e)=>handleChangeData(e, "payout")}
                        onBlur={formik.handleBlur}
                        // maxLength={2}
                      />
                       {formik.touched.payout && formik.errors.payout ? (
                        <div style={{ color: "red" }}>
                          {formik.errors.payout}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                  <div className="row g-3  mb-3">
                    <div className="col">
                    <h5 className="lable-custompayment-form">Enter Settlement Time (In Hours)*</h5>
                    <input
                        type="text"
                        className="form-control"
                        style={{fontSize:"16px", padding:"12px 25px", border:"1px solid #e5e5e5", background:"#f5f5f5"}}
                        placeholder="Enter Settlement Time*"
                        name="settlement_time"
                        value={formik?.values?.settlement_time}
                        onChange={(e)=>handleChangeData(e, "settlement_time")}
                        onBlur={formik.handleBlur}
                        // maxLength={3}
                      />
                       {formik.touched.settlement_time && formik.errors.settlement_time ? (
                        <div style={{ color: "red" }}>
                          {formik.errors.settlement_time}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>

                  <div class="adminplan_buttonwrapper">
                    {/* <button
                      type="button"
                      className="btn btn-secondary icon-btn adminplan_closebutton"
                      style={{background:"#fff", border:"1px solid #333333", color:"#333333"}}
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button> */}

                    <button
                      type="button"
                      className="btn btn-primary icon-btn adminplan_deletbutton"
                      aria-label="Close"
                      style={{ margin: "0 10px", background:"#333333", }}
                      onClick={formik.handleSubmit}
                    >
                      {isSubmit ? <CircularLoader size={20}/> : "Create Package"}
                    </button>
                  </div>

                </form>
                {/* <ToastContainer /> */}
              </div>
            </div>
          </div>
        </div>

      </>
      {/* Edit Popup */}
      <>
        <div
          className="modal fade"
          id="planselect"
          backdrop="static"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg dialog_wrapper_plan_superadmin">
            <div className="modal-content ">
              <div className="modal-header">
                <h5 className="modal-title L508" id="exampleModalLabel">
                  {/* Edit Payin/Out % */}
                  <h5 className="modal-title L508" id="exampleModalLabel" style={{justifyContent:"center", display:"flex"}}>
                  Edit Wallet Package
                </h5>
                  <h5 className="lable-custompayment-form-para">( Edit Payin/Payout Percentage and Settlement Time )</h5>
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="closeModalEdit"
                ></button>
              </div>
              <div className="modal-body ddd">
                <form id="editForm">

                  <div className="row g-3 mb-3">
                    <div className="col">
                    <h5 className="lable-custompayment-form">Edit Plan Name*</h5>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter plan name*"
                        name="editPlanName"
                        value={formData?.editPlanName}
                        onChange={handleChange}
                      />
                    </div>
                  
                  </div>
                  <div className="row g-3 mb-3">
                    <div className="col">
                    <h5 className="lable-custompayment-form">Edit Payin (In Percentage)*</h5>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Payin(%)*"
                        name="editPayin"
                        value={formData?.editPayin}
                        onChange={handleChange}
                      />
                    </div>
                  
                  </div>
                  <div className="row g-3  mb-3">
                    <div className="col">
                    <h5 className="lable-custompayment-form">Edit Payout (In Percentage)*</h5>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Payout(%)*"
                        name="editPayout"
                        value={formData?.editPayout}
                        onChange={handleChange}
                      />
                    
                    </div>
                  </div>
                  <div className="row g-3  mb-3">
                    <div className="col">
                    <h5 className="lable-custompayment-form">Edit Settlement Time (In Hours)*</h5>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter settlement_time*"
                        name="settlement_time"
                        value={formData?.settlement_time}
                        onChange={handleChange}
                      />
                      
                    </div>
                  </div>

                  <div class="adminplan_buttonwrapper">
                    <button
                      type="button"
                      className="btn btn-secondary icon-btn adminplan_closebutton"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary icon-btn adminplan_deletbutton"
                      aria-label="Close"
                      style={{ margin: "0 10px" }}
                      onClick={()=>handleEdit()}
                    >
                      {isSubmit ? <CircularLoader size={20}/> : "Save Changes"}
                    </button>
                  </div>
                      
                 
                </form>
                
              </div>
            </div>
          </div>
          
        </div>

      </>
      <ToastContainer />
    </div>
  );
}
export default CustomerPayinout;
